import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by"
      >©2019 <b><a href="http://gytni.com" target="_blank">GYTNI</a></b> Corp.
      All rights reserved.</span
    >
  `,
})
export class FooterComponent {}
